export default () => {
  const nextArrowHTML = `<button class="slick-next slick-arrow" aria-label="Next" type="button">
    <img
      alt=''
      class='carousel-slick__arrow-image carousel-slick__arrow-image--right'
      src='/public/images/arrow.svg'
    />
  </button>`;

  const prevArrowHTML = `<button class="slick-prev slick-arrow" aria-label="Prev" type="button">
    <img
      alt=''
      class='carousel-slick__arrow-image carousel-slick__arrow-image--left'
      src='/public/images/arrow.svg'
    />
  </button>`;

  $('[data-carousel-slick="section-tips"]').slick({
    nextArrow: nextArrowHTML,
    prevArrow: prevArrowHTML,
    dots: true,
    infinite: true,
    speed: 500,
    fade: true,
    cssEase: 'ease',
    slidesToShow: 1,
    adaptiveHeight: true,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 1150,
        settings: "unslick",
      }
    ]
  });

};
